export function upperAndLowerCaseValidator(rule, value, cb) {
  if (!value) return cb(true);

  const hasLowercase = value.split('').some((char) => /[a-z]/.test(char));
  const hasUppercase = value.split('').some((char) => /[A-Z]/.test(char));

  if (hasLowercase && hasUppercase) {
    cb();
  } else {
    cb(true);
  }

  return true;
}

export default {
  upperAndLowerCaseValidator,
};
